export default {"src":"/_next/static/media/kayla.6158a115.svg","height":176,"width":135,"blurWidth":0,"blurHeight":0};